export enum API {
    AllAttributes = '/attributes',
    AllConsumers = `/consumers/menu?context=`,
    AllLocationSetTypes = '/location-set-types?sort=weight,desc',
    AppInfo = '/info',
    AllAttributeGroups = '/attribute-groups?page=0&size=500&sort=sortOrder',
}

export enum API_ERRORS {
    GenericErrorMessage = 'Something went wrong on our end. Please try again in a few minutes. If the error persists,' +
        ' please contact Menu support.'
}

export const APIParams = {
    DeleteConsumer: (tag: string) => `/consumers/${tag}`,
    GetAllLocationSetsByTag: (tag: string) => `/locations/findByScopeTag?scopeTag=${tag}&sort=name`
};
